import {
  AppNotification,
  NotificationType,
} from '../../../components/notification/Notification'
import { useDeleteDebounce } from '../../../utils/useDeleteDebounce'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useArchiveMultipleBuffetMilletMutation } from '../../../core/api/BuffetMilletApi'
import { IChooseItems } from 'core/api/dto/BuffetDishDto'

interface UseDeleteMilletResponse {
  deletePopup: boolean
  onDeletePopupHandler: () => void
  onDeleteHandler: () => void
  closeDeletePopup: () => void
}

export const useDeleteMillet = (
  chooseItems: IChooseItems | null,
  setChooseItems: React.Dispatch<React.SetStateAction<IChooseItems | null>>,
): UseDeleteMilletResponse => {
  const [deletePopup, setDeletePopup] = useState(false)
  const [archiveMultipleMillet] = useArchiveMultipleBuffetMilletMutation()
  const { t } = useTranslation()

  const deleteCategoryHandler = async () => {
    if (!!chooseItems) {
      archiveMultipleMillet({
        millets: Object.keys(
          Object.fromEntries(
            Object.entries(chooseItems).filter((e) => e.includes(true)),
          ),
        ).map((item) => Number(item)),
      })
        .unwrap()
        .then(() => {
          AppNotification({
            msg: t('Выбранные тары успешно удалены!'),
            type: NotificationType.success,
          })
          setChooseItems(null)
        })
    }
  }

  const [onDeleteHandler] = useDeleteDebounce({
    fn: deleteCategoryHandler,
    extraText: t('Выбранные вами тары будут удалены!'),
  })

  const closeDeletePopup = () => setDeletePopup(false)
  const openDeletePopup = () => setDeletePopup(true)

  return {
    deletePopup,
    onDeletePopupHandler: openDeletePopup,
    onDeleteHandler,
    closeDeletePopup,
  }
}
